import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, Search, ShoppingCart, MessageCircle } from "lucide-react";
import { useCart, cartCount } from "@/store/cartStore";
import { buildWaLink, buildBulkMessage } from "@/lib/whatsapp";

export const BottomNav = ({ settings, onSearchOpen }) => {
  const items = useCart((s) => s.items);
  const count = cartCount(items);
  const waLink = settings?.whatsapp_number
    ? buildWaLink(settings.whatsapp_number, "Hello GlowinGifts, I have a query.")
    : buildWaLink("919999999999", buildBulkMessage());

  const itemCls = ({ isActive }) =>
    `flex flex-col items-center justify-center gap-0.5 min-w-[48px] min-h-[48px] flex-1 text-[10px] font-medium transition-colors ${
      isActive ? "text-[#9D00FF]" : "text-[#666666]"
    }`;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#ECECEC] shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50 flex justify-around items-stretch md:hidden pb-safe"
    >
      <NavLink to="/" end data-testid="bottomnav-home" className={itemCls}>
        <Home size={21} />
        Home
      </NavLink>
      <NavLink to="/categories" data-testid="bottomnav-categories" className={itemCls}>
        <LayoutGrid size={21} />
        Categories
      </NavLink>
      <button
        onClick={onSearchOpen}
        data-testid="bottomnav-search"
        className="flex flex-col items-center justify-center gap-0.5 min-w-[48px] min-h-[48px] flex-1 text-[10px] font-medium text-[#666666]"
      >
        <Search size={21} />
        Search
      </button>
      <NavLink to="/cart" data-testid="bottomnav-cart" className={itemCls}>
        <span className="relative">
          <ShoppingCart size={21} />
          {count > 0 && (
            <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-0.5 rounded-full gg-gradient text-white text-[9px] font-bold flex items-center justify-center">
              {count}
            </span>
          )}
        </span>
        Cart
      </NavLink>
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="bottomnav-whatsapp"
        className="flex flex-col items-center justify-center gap-0.5 min-w-[48px] min-h-[48px] flex-1 text-[10px] font-medium text-[#2EBD59]"
      >
        <MessageCircle size={21} />
        WhatsApp
      </a>
    </nav>
  );
};

export default BottomNav;
